import { NetworkError } from "@models/job.model";
import { httpRequest } from "../../http";

export class CommandGetJobNetworkErrors {
  async run(jobId: number): Promise<NetworkError[]> {
    try {
      const request = await httpRequest<NetworkError[]>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/jobs/${jobId}/network-errors/`,
        {
          method: "GET",
        }
      );
      return request ?? [];
    } catch (error) {
      // Same degradation as the logs proxy: an unreachable log group must render as
      // "no network errors", not as a broken panel.
      console.error("Error fetching job network errors:", error);
      return [];
    }
  }
}
